import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ContentPage } from 'src/app/enums/content-page.enum';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss']
})
export class ProductsComponent implements OnInit {
  products = ContentPage.esES.products;
  listProducts: any[]=[];
  type: any;
  pageCurrent: number = 1;
  typeCurrent: number = 1;
  language:string;
  crumbs: any[]=[];

  constructor(
    private route: ActivatedRoute
  ) { }

  ngOnInit() {

    let id = +this.route.snapshot.params['id'];
    this.typeCurrent = id ? id : 1;
    this.setCrumbs(id ? (id+1) : 2);
    this.language = localStorage.getItem('language');
    this.listProducts = ContentPage.esES.products.general.types[id ? (id-1):0].products;
    this.type = ContentPage.esES.products.general.types[id ? id-1 : 0];

    if (id) {
      if (id == 2) {
        this.type = this.language == 'esEN' ? ContentPage.esEN.products.general.types[id-1].expand = true :
        ContentPage.esES.products.general.types[id-1].expand = true;
      }else{
        this.type = this.language == 'esEN' ? ContentPage.esEN.products.general.types[id-1].expand = false :
        ContentPage.esES.products.general.types[id-1].expand = false;
      }
    }

    if (this.language == 'esEN') {
      this.products = this.language == 'esEN' ? ContentPage.esEN.products : ContentPage.esES.products;
      this.type = this.language == 'esEN' ? ContentPage.esEN.products.general.types[id ? (id-1) :0] : ContentPage.esES.products.general.types[id ? (id-1) :0];
      this.listProducts = this.language == 'esEN' ? ContentPage.esEN.products.general.types[id ? (id-1) :0].products : ContentPage.esES.products.general.types[id ? (id-1) :0].products;
      this.setCrumbs(id ? (id+1) : 2);
    }

  }

  ngAfterViewInit(): void {
    this.scrollToTop();
  }

  scrollToTop(): void {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 20);
  }

  setCrumbs(index){
    this.crumbs = this.products.crumbs.slice(0,2);
    this.crumbs.push(this.products.crumbs[index]);
  }

  nextPage(index, productSelected){
    productSelected.pageCurrent = index;
  }

  setTypeCurrent(index, type){
    this.typeCurrent = index;
    if (index != 2) {
      this.listProducts = this.language == 'esEN' ? ContentPage.esEN.products.general.types[index-1].products : ContentPage.esES.products.general.types[index-1].products;
      this.type = this.language == 'esEN' ? ContentPage.esEN.products.general.types[index-1] : ContentPage.esES.products.general.types[index-1];
      this.products.general.types[1].expand = false;
    }else{
      type.expand = true;
      this.showProducts(this.products.general.types[1],1)
    }
    this.crumbs = this.products.crumbs.slice(0,2);
    this.crumbs.push(this.products.crumbs[index+1])
  }

  showProducts(type, subcategory){
    this.type = this.language == 'esEN' ? ContentPage.esEN.products.general.types[1] : ContentPage.esES.products.general.types[1];
    let data = this.language == 'esEN' ? ContentPage.esEN.products.general.types[1].products : ContentPage.esES.products.general.types[1].products;
    this.listProducts = data.filter((element)=> element.subcategory == subcategory);
    type.subcategories.forEach(element => {
      element.selected = false;
    });
    type.subcategories[subcategory-1].selected = true;
  }

}
